import { Button, useMediaQuery, useTheme } from "@mui/material";

export function SubscribeButton({ isBest }) {
  const theme = useTheme();
  const isLaptop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Button
      variant="contained"
      sx={{
        bgcolor: isLaptop
          ? (isBest ? "#f3d45e" : "transparent")
          : "#f3d45e",
        border: isLaptop && !isBest ? "1px solid #000" : "none",
        color: "#000",
        px: 3,
        py: 1.5,
        fontSize: "16px",
        fontFamily: "Inter600",
        fontWeight: 600,
        textTransform: "none",
        borderRadius: "26px",
        width: "100%",
        transition: "all 0.3s ease",
        "&:hover": isLaptop && isBest
          ? { bgcolor: "#f3d45e" }
          : {}
      }}
    >
      Subscribe
    </Button>
  );
}
